import { useEffect, useState } from "react";
import { screenConfig } from "../data/screenConfig";

function SharedHeader({ currentScreen, onScreenChange, onReset }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    function closeOnEscape(event) {
      if (event.key === "Escape") setMenuOpen(false);
    }

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, []);

  function openScreen(screenNumber) {
    onScreenChange(screenNumber);
    setMenuOpen(false);
  }

  function resetJourney() {
    onReset();
    setMenuOpen(false);
  }

  return (
    <>
      <header className="main-header">
        <button
          className="brand"
          type="button"
          aria-label="Go to the first feedback screen"
          onClick={() => openScreen(1)}
        >
          <img
            className="brand-logo"
            src="/assets/common/sat-kartar-sanjeevan-logo.png"
            alt="Sat Kartar Sanjeevan"
          />
        </button>

        <button
          className="hamburger"
          type="button"
          aria-label="Open navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <button
        className={`menu-backdrop${menuOpen ? " is-open" : ""}`}
        type="button"
        aria-label="Close navigation"
        tabIndex={menuOpen ? 0 : -1}
        onClick={() => setMenuOpen(false)}
      />

      <aside
        className={`navigation-drawer${menuOpen ? " is-open" : ""}`}
        aria-hidden={!menuOpen}
        aria-label="Patient feedback screens"
      >
        <div className="navigation-drawer__head">
          <div>
            <small>Patient Feedback</small>
            <strong>Journey Menu</strong>
          </div>
          <button
            type="button"
            aria-label="Close navigation"
            onClick={() => setMenuOpen(false)}
          >
            ×
          </button>
        </div>

        <p className="navigation-drawer__note">
          Interactions work in this page only
        </p>

        <nav aria-label="Journey screens">
          {screenConfig.map((screen) => (
            <button
              className={screen.id === currentScreen ? "is-active" : ""}
              type="button"
              key={screen.id}
              onClick={() => openScreen(screen.id)}
            >
              <span>{screen.id}</span>
              {screen.menuLabel}
            </button>
          ))}
        </nav>

        <button
          className="navigation-drawer__reset"
          type="button"
          onClick={resetJourney}
        >
          Reset Journey
        </button>
      </aside>
    </>
  );
}

export default SharedHeader;
